import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAlertBanner, LazyAnimatedContainer, LazyAppButton, LazyAppButtonFileDownload, LazyAppFooter, LazyAppLink, LazyAvatarPlaceholder, LazyBard, LazyBreaky, LazyCmsButton, LazyComponentsLoader, LazyComponentsLoaderSustainability, LazyContainer, LazyContentSection, LazyCourseCard, LazyCourseDateCard, LazyCourseDates, LazyCourseSidebar, LazyCourtDecisionCard, LazyCourtDecisionMeta, LazyCourtDecisionMetaTiles, LazyCourtDecisionSidebar, LazyCustomForm, LazyDetailSummary, LazyDownloadButton, LazyDownloadsArea, LazyDownloadsAreaBreadcrumbs, LazyDownloadsAreaSpecific, LazyEntryCard, LazyEventCard, LazyExpertCard, LazyFactsAndFigures, LazyFileItem, LazyFileItemProtected, LazyFilter, LazyFolder, LazyFolderOrFile, LazyFormBuilder, LazyFullscreenVideo, LazyHerosLoader, LazyIcsButton, LazyImageDownloadable, LazyJobCard, LazyJobCardPersonal, LazyJobContacts, LazyJobMetaTiles, LazyJobSidebar, LazyLangSwitcher, LazyLangSwitcherMobile, LazyLinkItem, LazyList, LazyLiteratureCard, LazyLiteratureTableItem, LazyMetaTile, LazyNewsCard, LazyNewshubFacebook, LazyPagination, LazyScrolly, LazySearch, LazySearchInput, LazySocialShareIcons, LazySustainabilityCard, LazySustainabilityFactsSidebar, LazySustainabilityFactsSidebarItem, LazySustainabilitySidebar, LazySwiperButtons, LazySwitzerlandMap, LazyTag, LazyTeamMemberCard, LazyTeaserTextAndImageOrVideo, LazyTextAndImageOrVideo, LazyTooltip, LazyTransitionExpand, LazyTypeTag, LazyVideoPlayer, LazyBlueprintContact, LazyBlueprintCourse, LazyBlueprintCourtDecision, LazyBlueprintEvent, LazyBlueprintJob, LazyBlueprintLogin, LazyBlueprintNewsArticle, LazyBlueprintPage, LazyBlueprintPageEvent, LazyBlueprintPageLevel1, LazyBlueprintPageLevel2, LazyBlueprintPageSimple, LazyBlueprintProtectedEntry, LazyBlueprintSection, LazyBlueprintSustainabilityArticle, LazyBlueprintSustainabilityFact, LazyBlueprintUserRegistration, LazyJobForm, LazyPreview, LazyUserRegistrationForm, LazyEventProgram, LazyEventSpeakers, LazyEventSponsors, LazyAppMultiselect, LazyAppSelect, LazyCheckbox, LazyCheckboxGroup, LazyFileUpload, LazyInputField, LazyRadioGroup, LazySwitch, LazyTextEditor, LazyHeroContact, LazyHeroCourse, LazyHeroCourtDecision, LazyHeroEvent, LazyHeroHome, LazyHeroImageGradient, LazyHeroJob, LazyHeroLevel1, LazyHeroLevel2, LazyHeroNewsArticle, LazyHeroPagesEvent, LazyHeroSimple, LazyHeroSustainability, LazyAppleIcon, LazyArrowDownIcon, LazyArrowGrowIcon, LazyArrowIcon, LazyArrowSimpleIcon, LazyBenefitIcon, LazyCableCarIcon, LazyCalendarAlternateIcon, LazyCalendarIcon, LazyCalendarNoPlusIcon, LazyCaretDownIcon, LazyCaretRightIcon, LazyCartIcon, LazyCheckmarkIcon, LazyClockIcon, LazyCompanyIcon, LazyContactIcon, LazyCourtHammerIcon, LazyDocumentIcon, LazyDownloadIcon, LazyEditIcon, LazyEmployeesIcon, LazyExclamationMarkIcon, LazyExtendIcon, LazyExternalLinkIcon, LazyFacebookIcon, LazyFolderIcon, LazyFrenchFlagIcon, LazyGermanFlagIcon, LazyGlobeIcon, LazyGoogleCalendarIcon, LazyInfoIcon, LazyInstagramIcon, LazyLightBulbIcon, LazyLinkIcon, LazyLinkedinIcon, LazyLogoIcon, LazyMagnifyingLensIcon, LazyMailIcon, LazyMailOutlinedIcon, LazyMarkerIcon, LazyMarkerIconFat, LazyMicrosoft365Icon, LazyMicrosoftTeamsIcon, LazyMoneyBagIcon, LazyMountainIcon, LazyOrderedListIcon, LazyOutlookIcon, LazyPassengerTransportIcon, LazyPenIcon, LazyPhoneIcon, LazyPlusIcon, LazyProjectTimeIcon, LazyQuoteIcon, LazyRulerIcon, LazySearchIcon, LazyShakingHandsIcon, LazySignOutIcon, LazySpinIcon, LazySuitCaseIcon, LazySunColdIcon, LazyTriangleIcon, LazyTwitterIcon, LazyUnorderedListIcon, LazyUserIcon, LazyWalletIcon, LazyWhatsappIcon, LazyYoutubeIcon, LazyBreadcrumbs, LazyMobileMenu, LazyMobileMenuButton, LazyMobileNavItem, LazyMobileNavItemWithSubmenu, LazyNavDropdown, LazyNavItem, LazyNavigation, LazyAccordionGroup, LazyConsulting, LazyConsultingTwoPeople, LazyCoursesOverview, LazyCoursesTeaser, LazyCourtDecisionsOverview, LazyCourtDecisionsTeaser, LazyCustomImageOrVideo, LazyCustomText, LazyDownloads, LazyDownloadsProtected, LazyEventsTeaser, LazyExpertsOverview, LazyFlipbookIntegration, LazyGallery, LazyImageSlider, LazyImagesInline, LazyImagesTeaser, LazyImagesTeaserInfinity, LazyInteractiveMapSwitzerland, LazyJobsOverview, LazyJobsTeaser, LazyLinks, LazyListTwoCols, LazyLiteratureDatabase, LazyLocationAndContactMap, LazyNewsTeaser, LazyNewshub, LazyNewsletter, LazyOpinionPoll, LazySustainabilityTeaser, LazySustainabilityhub, LazyTeamOverview, LazyTeaserSlider, LazyTeaserWithBackgroundImage, LazyTestimonial } from '#components'
const lazyGlobalComponents = [
  ["AlertBanner", LazyAlertBanner],
["AnimatedContainer", LazyAnimatedContainer],
["AppButton", LazyAppButton],
["AppButtonFileDownload", LazyAppButtonFileDownload],
["AppFooter", LazyAppFooter],
["AppLink", LazyAppLink],
["AvatarPlaceholder", LazyAvatarPlaceholder],
["Bard", LazyBard],
["Breaky", LazyBreaky],
["CmsButton", LazyCmsButton],
["ComponentsLoader", LazyComponentsLoader],
["ComponentsLoaderSustainability", LazyComponentsLoaderSustainability],
["Container", LazyContainer],
["ContentSection", LazyContentSection],
["CourseCard", LazyCourseCard],
["CourseDateCard", LazyCourseDateCard],
["CourseDates", LazyCourseDates],
["CourseSidebar", LazyCourseSidebar],
["CourtDecisionCard", LazyCourtDecisionCard],
["CourtDecisionMeta", LazyCourtDecisionMeta],
["CourtDecisionMetaTiles", LazyCourtDecisionMetaTiles],
["CourtDecisionSidebar", LazyCourtDecisionSidebar],
["CustomForm", LazyCustomForm],
["DetailSummary", LazyDetailSummary],
["DownloadButton", LazyDownloadButton],
["DownloadsArea", LazyDownloadsArea],
["DownloadsAreaBreadcrumbs", LazyDownloadsAreaBreadcrumbs],
["DownloadsAreaSpecific", LazyDownloadsAreaSpecific],
["EntryCard", LazyEntryCard],
["EventCard", LazyEventCard],
["ExpertCard", LazyExpertCard],
["FactsAndFigures", LazyFactsAndFigures],
["FileItem", LazyFileItem],
["FileItemProtected", LazyFileItemProtected],
["Filter", LazyFilter],
["Folder", LazyFolder],
["FolderOrFile", LazyFolderOrFile],
["FormBuilder", LazyFormBuilder],
["FullscreenVideo", LazyFullscreenVideo],
["HerosLoader", LazyHerosLoader],
["IcsButton", LazyIcsButton],
["ImageDownloadable", LazyImageDownloadable],
["JobCard", LazyJobCard],
["JobCardPersonal", LazyJobCardPersonal],
["JobContacts", LazyJobContacts],
["JobMetaTiles", LazyJobMetaTiles],
["JobSidebar", LazyJobSidebar],
["LangSwitcher", LazyLangSwitcher],
["LangSwitcherMobile", LazyLangSwitcherMobile],
["LinkItem", LazyLinkItem],
["List", LazyList],
["LiteratureCard", LazyLiteratureCard],
["LiteratureTableItem", LazyLiteratureTableItem],
["MetaTile", LazyMetaTile],
["NewsCard", LazyNewsCard],
["NewshubFacebook", LazyNewshubFacebook],
["Pagination", LazyPagination],
["Scrolly", LazyScrolly],
["Search", LazySearch],
["SearchInput", LazySearchInput],
["SocialShareIcons", LazySocialShareIcons],
["SustainabilityCard", LazySustainabilityCard],
["SustainabilityFactsSidebar", LazySustainabilityFactsSidebar],
["SustainabilityFactsSidebarItem", LazySustainabilityFactsSidebarItem],
["SustainabilitySidebar", LazySustainabilitySidebar],
["SwiperButtons", LazySwiperButtons],
["SwitzerlandMap", LazySwitzerlandMap],
["Tag", LazyTag],
["TeamMemberCard", LazyTeamMemberCard],
["TeaserTextAndImageOrVideo", LazyTeaserTextAndImageOrVideo],
["TextAndImageOrVideo", LazyTextAndImageOrVideo],
["Tooltip", LazyTooltip],
["TransitionExpand", LazyTransitionExpand],
["TypeTag", LazyTypeTag],
["VideoPlayer", LazyVideoPlayer],
["BlueprintContact", LazyBlueprintContact],
["BlueprintCourse", LazyBlueprintCourse],
["BlueprintCourtDecision", LazyBlueprintCourtDecision],
["BlueprintEvent", LazyBlueprintEvent],
["BlueprintJob", LazyBlueprintJob],
["BlueprintLogin", LazyBlueprintLogin],
["BlueprintNewsArticle", LazyBlueprintNewsArticle],
["BlueprintPage", LazyBlueprintPage],
["BlueprintPageEvent", LazyBlueprintPageEvent],
["BlueprintPageLevel1", LazyBlueprintPageLevel1],
["BlueprintPageLevel2", LazyBlueprintPageLevel2],
["BlueprintPageSimple", LazyBlueprintPageSimple],
["BlueprintProtectedEntry", LazyBlueprintProtectedEntry],
["BlueprintSection", LazyBlueprintSection],
["BlueprintSustainabilityArticle", LazyBlueprintSustainabilityArticle],
["BlueprintSustainabilityFact", LazyBlueprintSustainabilityFact],
["BlueprintUserRegistration", LazyBlueprintUserRegistration],
["JobForm", LazyJobForm],
["Preview", LazyPreview],
["UserRegistrationForm", LazyUserRegistrationForm],
["EventProgram", LazyEventProgram],
["EventSpeakers", LazyEventSpeakers],
["EventSponsors", LazyEventSponsors],
["AppMultiselect", LazyAppMultiselect],
["AppSelect", LazyAppSelect],
["Checkbox", LazyCheckbox],
["CheckboxGroup", LazyCheckboxGroup],
["FileUpload", LazyFileUpload],
["InputField", LazyInputField],
["RadioGroup", LazyRadioGroup],
["Switch", LazySwitch],
["TextEditor", LazyTextEditor],
["HeroContact", LazyHeroContact],
["HeroCourse", LazyHeroCourse],
["HeroCourtDecision", LazyHeroCourtDecision],
["HeroEvent", LazyHeroEvent],
["HeroHome", LazyHeroHome],
["HeroImageGradient", LazyHeroImageGradient],
["HeroJob", LazyHeroJob],
["HeroLevel1", LazyHeroLevel1],
["HeroLevel2", LazyHeroLevel2],
["HeroNewsArticle", LazyHeroNewsArticle],
["HeroPagesEvent", LazyHeroPagesEvent],
["HeroSimple", LazyHeroSimple],
["HeroSustainability", LazyHeroSustainability],
["AppleIcon", LazyAppleIcon],
["ArrowDownIcon", LazyArrowDownIcon],
["ArrowGrowIcon", LazyArrowGrowIcon],
["ArrowIcon", LazyArrowIcon],
["ArrowSimpleIcon", LazyArrowSimpleIcon],
["BenefitIcon", LazyBenefitIcon],
["CableCarIcon", LazyCableCarIcon],
["CalendarAlternateIcon", LazyCalendarAlternateIcon],
["CalendarIcon", LazyCalendarIcon],
["CalendarNoPlusIcon", LazyCalendarNoPlusIcon],
["CaretDownIcon", LazyCaretDownIcon],
["CaretRightIcon", LazyCaretRightIcon],
["CartIcon", LazyCartIcon],
["CheckmarkIcon", LazyCheckmarkIcon],
["ClockIcon", LazyClockIcon],
["CompanyIcon", LazyCompanyIcon],
["ContactIcon", LazyContactIcon],
["CourtHammerIcon", LazyCourtHammerIcon],
["DocumentIcon", LazyDocumentIcon],
["DownloadIcon", LazyDownloadIcon],
["EditIcon", LazyEditIcon],
["EmployeesIcon", LazyEmployeesIcon],
["ExclamationMarkIcon", LazyExclamationMarkIcon],
["ExtendIcon", LazyExtendIcon],
["ExternalLinkIcon", LazyExternalLinkIcon],
["FacebookIcon", LazyFacebookIcon],
["FolderIcon", LazyFolderIcon],
["FrenchFlagIcon", LazyFrenchFlagIcon],
["GermanFlagIcon", LazyGermanFlagIcon],
["GlobeIcon", LazyGlobeIcon],
["GoogleCalendarIcon", LazyGoogleCalendarIcon],
["InfoIcon", LazyInfoIcon],
["InstagramIcon", LazyInstagramIcon],
["LightBulbIcon", LazyLightBulbIcon],
["LinkIcon", LazyLinkIcon],
["LinkedinIcon", LazyLinkedinIcon],
["LogoIcon", LazyLogoIcon],
["MagnifyingLensIcon", LazyMagnifyingLensIcon],
["MailIcon", LazyMailIcon],
["MailOutlinedIcon", LazyMailOutlinedIcon],
["MarkerIcon", LazyMarkerIcon],
["MarkerIconFat", LazyMarkerIconFat],
["Microsoft365Icon", LazyMicrosoft365Icon],
["MicrosoftTeamsIcon", LazyMicrosoftTeamsIcon],
["MoneyBagIcon", LazyMoneyBagIcon],
["MountainIcon", LazyMountainIcon],
["OrderedListIcon", LazyOrderedListIcon],
["OutlookIcon", LazyOutlookIcon],
["PassengerTransportIcon", LazyPassengerTransportIcon],
["PenIcon", LazyPenIcon],
["PhoneIcon", LazyPhoneIcon],
["PlusIcon", LazyPlusIcon],
["ProjectTimeIcon", LazyProjectTimeIcon],
["QuoteIcon", LazyQuoteIcon],
["RulerIcon", LazyRulerIcon],
["SearchIcon", LazySearchIcon],
["ShakingHandsIcon", LazyShakingHandsIcon],
["SignOutIcon", LazySignOutIcon],
["SpinIcon", LazySpinIcon],
["SuitCaseIcon", LazySuitCaseIcon],
["SunColdIcon", LazySunColdIcon],
["TriangleIcon", LazyTriangleIcon],
["TwitterIcon", LazyTwitterIcon],
["UnorderedListIcon", LazyUnorderedListIcon],
["UserIcon", LazyUserIcon],
["WalletIcon", LazyWalletIcon],
["WhatsappIcon", LazyWhatsappIcon],
["YoutubeIcon", LazyYoutubeIcon],
["Breadcrumbs", LazyBreadcrumbs],
["MobileMenu", LazyMobileMenu],
["MobileMenuButton", LazyMobileMenuButton],
["MobileNavItem", LazyMobileNavItem],
["MobileNavItemWithSubmenu", LazyMobileNavItemWithSubmenu],
["NavDropdown", LazyNavDropdown],
["NavItem", LazyNavItem],
["Navigation", LazyNavigation],
["AccordionGroup", LazyAccordionGroup],
["Consulting", LazyConsulting],
["ConsultingTwoPeople", LazyConsultingTwoPeople],
["CoursesOverview", LazyCoursesOverview],
["CoursesTeaser", LazyCoursesTeaser],
["CourtDecisionsOverview", LazyCourtDecisionsOverview],
["CourtDecisionsTeaser", LazyCourtDecisionsTeaser],
["CustomImageOrVideo", LazyCustomImageOrVideo],
["CustomText", LazyCustomText],
["Downloads", LazyDownloads],
["DownloadsProtected", LazyDownloadsProtected],
["EventsTeaser", LazyEventsTeaser],
["ExpertsOverview", LazyExpertsOverview],
["FlipbookIntegration", LazyFlipbookIntegration],
["Gallery", LazyGallery],
["ImageSlider", LazyImageSlider],
["ImagesInline", LazyImagesInline],
["ImagesTeaser", LazyImagesTeaser],
["ImagesTeaserInfinity", LazyImagesTeaserInfinity],
["InteractiveMapSwitzerland", LazyInteractiveMapSwitzerland],
["JobsOverview", LazyJobsOverview],
["JobsTeaser", LazyJobsTeaser],
["Links", LazyLinks],
["ListTwoCols", LazyListTwoCols],
["LiteratureDatabase", LazyLiteratureDatabase],
["LocationAndContactMap", LazyLocationAndContactMap],
["NewsTeaser", LazyNewsTeaser],
["Newshub", LazyNewshub],
["Newsletter", LazyNewsletter],
["OpinionPoll", LazyOpinionPoll],
["SustainabilityTeaser", LazySustainabilityTeaser],
["Sustainabilityhub", LazySustainabilityhub],
["TeamOverview", LazyTeamOverview],
["TeaserSlider", LazyTeaserSlider],
["TeaserWithBackgroundImage", LazyTeaserWithBackgroundImage],
["Testimonial", LazyTestimonial],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
